<script>
	const page = require('page');
	const model = require('model/model');

	const googleClassroomUtilities = require('utilities/googleClassroomUtilities');
	const authenticateWithGoogleClassroom = googleClassroomUtilities.authenticateWithGoogleClassroom;

	const utilities = require('utilities');

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},
		modelData: ['localGCAccessToken', 'gcAddon'],
		mounted() {
			this.$subscribe('modal-opened', (modalId, options) => {
				if (modalId !== 'modal-create-class') {
					return;
				}

				this.createAssignmentMessage = options.createAssignmentMessage || false;
				this.returnToProduct = options.returnToProduct || null;
				this.createReadWorksClass = false;

				if (this.gcAddon) {
					this.importGoogleClass();
				}
			});

			model.change('localGCAccessToken', () => {
				let waitingOnGoogleAuth = this.waitingOnGoogleAuth;
				this.waitingOnGoogleAuth = false;

				if (waitingOnGoogleAuth) {
					this.importGoogleClass();
				}
			});
		},
		data() {
			return {
				createClassForm: {
					name: null,
					grade: null
				},
				returnToProduct: null,
				createAssignmentMessage: false,
				createReadWorksClass: false,
				waitingOnGoogleAuth: false
			};
		},

		methods: {
			forwardToRosteringSelection(data, cb) {
				var hash = '';
				if (this.returnToProduct) {
					hash = '#!returnToProduct:' + this.returnToProduct;
					this.returnToProduct = null;
				}

				model.set('newClass', {
					name: this.createClassForm.name,
					grade: this.createClassForm.grade
				});

				page(encodeURI('/rostering-selection' + hash));

				this.createClassForm.name = '';

				cb(null, {
					ok: true
				});
			},

			createAReadWorksClass() {
				this.createReadWorksClass = true;
			},

			backToClassChoice() {
				this.createReadWorksClass = false;
			},

			importGoogleClass() {
				let localGCAccessToken = model.get('localGCAccessToken');
				if (!localGCAccessToken) {
					authenticateWithGoogleClassroom();
					this.waitingOnGoogleAuth = true;
				} else {
					utilities.openModal('#modal-google-classroom-import');
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/flexbox';
	@import 'config/colors';

	#modal-create-class {
		.modal-content-header {
			position: relative;
			.modal-back {
				position: absolute;
				left: 0;
				font-size: 2rem;
				line-height: 1.5rem;
				cursor: pointer;
			}
		}
		button.gc-button {
			margin: 1rem 0;
		}
		.or-container {
			@include flexbox();
			@include flex-direction(row);
			margin: 1rem 0;
			.or-border {
				flex: 1;
			}
			.or-text {
				margin: 0.25rem 1rem;
			}
		}
	}
</style>
<template>
	<!-- Start of modal dialog: create class -->
	<div
		id="modal-create-class"
		class="modal"
		data-modal-window>
		<div class="modal-container">
			<div class="modal-window">
				<div class="modal-window-wrap">
					<button
						class="modal-close"
						data-modal-close>
						<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
					</button>
					<section class="modal-content">
						<header class="modal-content-header">
							<button
								class="modal-back button -link"
								v-if="createReadWorksClass"
								aria-label="Back to Class Choice"
								@click="backToClassChoice">
								&larr;
							</button>
							<h2>Create a Class</h2>
							<p v-if="createAssignmentMessage">To create an Assignment, first create a Class.</p>
						</header>
						<div
							class="modal-content-main"
							v-if="!createReadWorksClass">
							<button
								class="gc-button button -large -full-width"
								@click="createAReadWorksClass">
								Create a New Class
							</button>
							<div class="or-container">
								<hr class="or-border" />
								<span class="or-text">OR</span>
								<hr class="or-border" />
							</div>
							<button
								class="gc-button button -large -full-width"
								@click="importGoogleClass">
								Import from Google Classroom
							</button>
						</div>
						<div
							class="modal-content-main"
							v-if="createReadWorksClass">
							<form-submitter
								class="form asteriskoids class-meta-form"
								form-name="createClassForm"
								:form-data.sync="createClassForm"
								:submit-to="forwardToRosteringSelection">
								<auto-form-row
									v-bind:data.sync="createClassForm.grade"
									type="grade"
									placeholder="Grade"
									row-class="label-hidden-visually"
									required>
								</auto-form-row>
								<auto-form-row
									v-bind:data.sync="createClassForm.name"
									type="className"
									placeholder="Class Name"
									row-class="label-hidden-visually"
									required
									unsafe>
								</auto-form-row>
								<auto-form-row
									class="-full-width"
									v-bind:all-valid="createClassForm.allValid"
									type="submit">
									Next
								</auto-form-row>
							</form-submitter>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
	<!-- End of modal dialog: create class -->
</template>
